var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bg" }, [
      _c("div", { staticClass: "notification" }, [
        _c("span", [_vm._v("Uma solicitação de assinatura foi recusada.")]),
        _vm._v(" "),
        _c("div", { staticClass: "btn btn-white-outline btn-small" }, [
          _vm._v("ver")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "notification" }, [
        _c("span", [
          _vm._v(
            "Seu pedido de 28/03/2018 foi confirmado pela profissional Bozena."
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "footer" }, [
        _vm._v("ver todas as notificações")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43a3e4e8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43a3e4e8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notifications.vue
// module id = null
// module chunks = 